import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Logo from './Logo';

const Navigation = () => {
  const { user, guestMode, logout } = useAuth();
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);

  // Only render navigation if we have a user or in guest mode
  if (!user && !guestMode) {
    return null;
  }

  return (
    <div className="bg-white shadow-sm border-b sticky top-0 z-50" style={{ borderColor: 'rgba(24, 24, 24, 0.1)' }}>
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <Logo />
          <div className="hidden md:flex items-center gap-4">
            <Link to="/" className="nav-link">AI Planner</Link>
            <Link to="/custom-weekly-plan" className="nav-link">Meal Planner</Link>
            <Link to="/dashboard" className="nav-link">Tracker</Link>
            <Link to="/saved-plans" className="nav-link">Saved Plans</Link>
            <Link to="/custom-meals" className="nav-link">My Meals</Link>
            <Link to="/food-database" className="nav-link">Food Database</Link>
            <Link to="/community" className="nav-link">Community</Link>
            <Link to="/youtube-meal" className="nav-link bg-purple-100 text-purple-700 px-3 py-1 rounded-md hover:bg-purple-200 transition-colors">
              + Create from YouTube
            </Link>
            {guestMode ? (
              <>
                <span className="body-medium ml-2 px-3 py-1 bg-yellow-100 text-yellow-700 rounded-md">
                  👤 Guest Mode
                </span>
                <button 
                  onClick={() => navigate('/login')} 
                  className="btn-primary"
                >
                  Sign In
                </button>
              </>
            ) : (
              <>
                <span className="body-medium ml-2" style={{ color: 'rgb(112, 112, 112)' }}>
                  Hi, {user?.name || 'Guest'}!
                </span>
                <button 
                  onClick={() => { logout(); navigate('/login'); }} 
                  className="btn-secondary"
                >
                  Logout
                </button>
              </>
            )}
          </div>

          <button onClick={() => setShowMenu(!showMenu)} className="md:hidden">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        {showMenu && (
          <div className="md:hidden mt-4 space-y-2">
            <Link to="/" className="block py-2 font-medium" onClick={() => setShowMenu(false)}>Meal Planner</Link>
            <Link to="/dashboard" className="block py-2" onClick={() => setShowMenu(false)}>Tracker</Link>
            <Link to="/saved-plans" className="block py-2" onClick={() => setShowMenu(false)}>Saved Plans</Link>
            <Link to="/custom-meals" className="block py-2" onClick={() => setShowMenu(false)}>My Meals</Link>
            <Link to="/custom-weekly-plan" className="block py-2" onClick={() => setShowMenu(false)}>Custom Weekly</Link>
            <Link to="/community" className="block py-2" onClick={() => setShowMenu(false)}>Community</Link>
            <Link to="/youtube-meal" className="block py-2 text-purple-600 font-medium" onClick={() => setShowMenu(false)}>
              + Create from YouTube
            </Link>
            <div className="pt-2 mt-2 border-t border-gray-100">
              {guestMode ? (
                <>
                  <span className="block py-2 text-sm px-3 py-2 bg-yellow-100 text-yellow-700 rounded-md text-center font-medium">
                    👤 Guest Mode
                  </span>
                  <button 
                    onClick={() => { 
                      setShowMenu(false);
                      navigate('/login'); 
                    }} 
                    className="btn-primary w-full mt-2"
                  >
                    Sign In
                  </button>
                </>
              ) : (
                <>
                  <span className="block py-2 text-sm text-gray-500">
                    Hi, {user?.name || 'Guest'}!
                  </span>
                  <button 
                    onClick={() => { 
                      setShowMenu(false);
                      logout(); 
                      navigate('/login'); 
                    }} 
                    className="btn-secondary w-full mt-2"
                  >
                    Logout
                  </button>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Navigation;